export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 w-full max-w-[1200px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新 · 防走失导航
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              51吃瓜网址
              <span className="block text-primary-600 mt-1">全网最新吃瓜入口一站式导航</span>
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl lg:max-w-none mb-6">
              聚合51吃瓜网址新入口、51吃瓜官网全网最新等官方直达通道，同步追踪51吃瓜网站入口最新动态。
              本站每日更新防走失域名与备用地址，涵盖娱乐圈最新爆料、明星动态追踪、热播剧综吐槽等热门内容，
              确保您在任何情况下都能一键直达不迷路，畅享全网最热吃瓜资讯。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-700">每日实时更新</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-700">多线路防屏蔽</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-700">全网内容聚合</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览焦点专题
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-300 text-foreground-700 hover:text-primary-600 font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                查看最新快讯
                <i className="ri-flashlight-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20illustration%20with%20layered%20geometric%20shapes%20in%20coral%20red%20and%20cream%20tones%2C%20modern%20news%20media%20aesthetic%2C%20dynamic%20composition%20with%20flowing%20curves%20and%20soft%20gradients%2C%20digital%20information%20network%20concept%2C%20clean%20minimalist%20style%20with%20warm%20atmosphere&width=1200&height=900&seq=hero-main-51chigua&orientation=landscape"
                alt="51吃瓜网址 - 全网最新吃瓜入口一站式导航"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}